import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { configureAmplify } from '@eir/aws-authorization';
import GroupContractNorwayView from './views/GroupContractNorway/GroupContractNorwayView';
import InsuranceLetterNorwayView from './views/InsuranceLetterNorway/InsuranceLetterNorwayView';
import './styles/fonts.css';
import GlobalStyle from './styles/globalStyle';
configureAmplify(
  {
    endpointName: 'AvonovaAPI',
    endpointUrl: process.env.REACT_APP_AWS_ENDPOINT_URL,
  },
  true
);
const App = () => {
  return (
    <Router>
      <GlobalStyle />
      <Switch>
        <Route
          exact
          path='/p/:policyId'
          render={({ match }) => {
            window.location.href = `${process.env.REACT_APP_PARTNER_HUB_URL}p/${match.params.policyId}`;
            return null;
          }}
        />
        <Route
          exact
          path='/q/:quoteId'
          render={({ match }) => {
            window.location.href = `${process.env.REACT_APP_PARTNER_HUB_URL}q/${match.params.quoteId}`;
            return null;
          }}
        />
        <Route exact path='/q-old/:quoteId' component={GroupContractNorwayView} />
        <Route exact path='/p-old/:policyId' component={InsuranceLetterNorwayView} />
      </Switch>
    </Router>
  );
};
export default App;
